var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content" },
    [
      _c("h1", { staticClass: "titulo" }, [_vm._v("Manual do usuário")]),
      _c("p", [_vm._v(_vm._s(_vm.DESCRICAO))]),
      _vm.isEstadoMA()
        ? _c(
            "el-row",
            { staticClass: "cards-row" },
            [
              _c("el-col", [
                _c(
                  "div",
                  { staticClass: "manual-container align-end" },
                  [
                    _vm.MANUAL_OFF
                      ? _c(
                          "el-card",
                          {
                            staticClass: "card",
                            attrs: { "body-style": { width: "100%" } }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-content" },
                              [
                                _c("img", {
                                  staticClass: "icon-card",
                                  attrs: {
                                    src: require("@/assets/images/manualOffline.png"),
                                    height: "100px",
                                    width: "80px"
                                  }
                                }),
                                _c("p", { staticClass: "text-center" }, [
                                  _vm._v("Baixar Manual do SiCARF Off-line")
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "botao",
                                    attrs: {
                                      type: "success",
                                      loading: _vm.loading,
                                      icon: "fas fa-cloud-download-alt"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.baixarManual("Off")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _c("b", { staticClass: "text-botao" }, [
                                        _vm._v("Baixar")
                                      ])
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.VIDEOS_TUTORIAIS
                      ? _c("iframe", {
                          staticClass: "default-iframe",
                          attrs: {
                            showinfo: "0",
                            width: "100%",
                            height: "350",
                            rel: "0",
                            src: _vm.VIDEOS_TUTORIAIS.MANUAL_USUARIO_OFF,
                            frameborder: "0",
                            allow:
                              "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                            allowfullscreen: "allowfullscreen",
                            modestbranding: "1"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("el-col", [
                _c(
                  "div",
                  { staticClass: "manual-container align-end" },
                  [
                    _vm.MANUAL_OFF
                      ? _c(
                          "el-card",
                          {
                            staticClass: "card",
                            attrs: { "body-style": { width: "100%" } }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-content" },
                              [
                                _c("img", {
                                  staticClass: "icon-card",
                                  attrs: {
                                    src: require("@/assets/images/manualOffline.png"),
                                    height: "100px",
                                    width: "80px"
                                  }
                                }),
                                _c("p", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "Baixar Manual de Cadastro de Processos Onerosos e Não Onerosos Rurais"
                                  )
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "botao",
                                    attrs: {
                                      type: "success",
                                      loading: _vm.loading,
                                      icon: "fas fa-cloud-download-alt"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.baixarManual(
                                          "Off_oneroso_nao_oneroso"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _c("b", { staticClass: "text-botao" }, [
                                        _vm._v("Baixar")
                                      ])
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.VIDEOS_TUTORIAIS
                      ? _c("iframe", {
                          staticClass: "default-iframe",
                          attrs: {
                            showinfo: "0",
                            width: "100%",
                            height: "350",
                            rel: "0",
                            src: _vm.VIDEOS_TUTORIAIS.MANUAL_USUARIO_OFF,
                            frameborder: "0",
                            allow:
                              "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                            allowfullscreen: "allowfullscreen",
                            modestbranding: "1"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("el-col", [
                _c(
                  "div",
                  { staticClass: "manual-container align-end" },
                  [
                    _vm.MANUAL_OFF
                      ? _c(
                          "el-card",
                          {
                            staticClass: "card",
                            attrs: { "body-style": { width: "100%" } }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-content" },
                              [
                                _c("img", {
                                  staticClass: "icon-card",
                                  attrs: {
                                    src: require("@/assets/images/manualOffline.png"),
                                    height: "100px",
                                    width: "80px"
                                  }
                                }),
                                _c("p", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "Baixar Manual de Cadastro de Processos de Territórios Tradicionais - TT"
                                  )
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "botao",
                                    attrs: {
                                      type: "success",
                                      loading: _vm.loading,
                                      icon: "fas fa-cloud-download-alt",
                                      disabled: true
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.baixarManual("Off_tq")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _c("b", { staticClass: "text-botao" }, [
                                        _vm._v("Baixar")
                                      ])
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.VIDEOS_TUTORIAIS
                      ? _c("iframe", {
                          staticClass: "default-iframe",
                          attrs: {
                            showinfo: "0",
                            width: "100%",
                            height: "350",
                            rel: "0",
                            src: _vm.VIDEOS_TUTORIAIS.MANUAL_USUARIO_OFF,
                            frameborder: "0",
                            allow:
                              "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                            allowfullscreen: "allowfullscreen",
                            modestbranding: "1"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "manual-container align-start" },
                [
                  _vm.MANUAL_ON
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card",
                          attrs: { "body-style": { width: "100%" } }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-content" },
                            [
                              _c("img", {
                                staticClass: "icon-card",
                                attrs: {
                                  src: require("@/assets/images/manualOnline.png"),
                                  height: "100px",
                                  width: "80px"
                                }
                              }),
                              _c("p", { staticClass: "text-center" }, [
                                _vm._v("Baixar Manual do SiCARF On-line")
                              ]),
                              _c(
                                "el-button",
                                {
                                  staticClass: "botao",
                                  attrs: {
                                    type: "success",
                                    loading: _vm.loading,
                                    icon: "fas fa-cloud-download-alt"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.baixarManual("On")
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _c("b", { staticClass: "text-botao" }, [
                                      _vm._v("Baixar")
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.VIDEOS_TUTORIAIS
                    ? _c("iframe", {
                        staticClass: "default-iframe",
                        attrs: {
                          showinfo: "0",
                          width: "100%",
                          height: "350",
                          rel: "0",
                          src: _vm.VIDEOS_TUTORIAIS.MANUAL_USUARIO,
                          frameborder: "0",
                          allow:
                            "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                          allowfullscreen: "allowfullscreen",
                          modestbranding: "1"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c("el-row", { staticClass: "cards-row" }, [
            _c(
              "div",
              { staticClass: "manual-container align-end" },
              [
                _vm.MANUAL_OFF
                  ? _c(
                      "el-card",
                      {
                        staticClass: "card",
                        attrs: { "body-style": { width: "100%" } }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card-content" },
                          [
                            _c("img", {
                              staticClass: "icon-card",
                              attrs: {
                                src: require("@/assets/images/manualOffline.png"),
                                height: "100px",
                                width: "80px"
                              }
                            }),
                            _c("p", { staticClass: "text-center" }, [
                              _vm._v("Baixar Manual do SiCARF Off-line")
                            ]),
                            _c(
                              "el-button",
                              {
                                staticClass: "botao",
                                attrs: {
                                  type: "success",
                                  loading: _vm.loading,
                                  icon: "fas fa-cloud-download-alt",
                                  disabled: true
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.baixarManual("Off")
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _c("b", { staticClass: "text-botao" }, [
                                    _vm._v("Baixar")
                                  ])
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.VIDEOS_TUTORIAIS
                  ? _c("iframe", {
                      staticClass: "default-iframe",
                      attrs: {
                        showinfo: "0",
                        width: "100%",
                        height: "350",
                        rel: "0",
                        src: _vm.VIDEOS_TUTORIAIS.MANUAL_USUARIO_OFF,
                        frameborder: "0",
                        allow:
                          "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                        allowfullscreen: "allowfullscreen",
                        modestbranding: "1"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "manual-container align-start" },
              [
                _vm.MANUAL_ON
                  ? _c(
                      "el-card",
                      {
                        staticClass: "card",
                        attrs: { "body-style": { width: "100%" } }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card-content" },
                          [
                            _c("img", {
                              staticClass: "icon-card",
                              attrs: {
                                src: require("@/assets/images/manualOnline.png"),
                                height: "100px",
                                width: "80px"
                              }
                            }),
                            _c("p", { staticClass: "text-center" }, [
                              _vm._v("Baixar Manual do SiCARF On-line")
                            ]),
                            _c(
                              "el-button",
                              {
                                staticClass: "botao",
                                attrs: {
                                  type: "success",
                                  loading: _vm.loading,
                                  icon: "fas fa-cloud-download-alt",
                                  disabled: true
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.baixarManual("On")
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _c("b", { staticClass: "text-botao" }, [
                                    _vm._v("Baixar")
                                  ])
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.VIDEOS_TUTORIAIS
                  ? _c("iframe", {
                      staticClass: "default-iframe",
                      attrs: {
                        showinfo: "0",
                        width: "100%",
                        height: "350",
                        rel: "0",
                        src: _vm.VIDEOS_TUTORIAIS.MANUAL_USUARIO,
                        frameborder: "0",
                        allow:
                          "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                        allowfullscreen: "allowfullscreen",
                        modestbranding: "1"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9d41a86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9d41a86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/ManualUsuario.vue
// module id = null
// module chunks = 